import * as Types from "./types";
import { types, paramProperties } from "./utils";

export { types };

export const schema = [
  ...Types.schema,
  {
    id: "/Types/Param",
    type: "object",
    required: ["name", "type"],
    properties: {
      name: {
        label: "Name",
        $ref: "/Name/Required",
        minLength: 1,
        default: "",
      },
      label: { label: "Label", type: "string", default: "" },
      description: { label: "Description", type: "string", default: "" },
      hidden: { label: "Hidden", type: "boolean", default: false },
      required: { label: "Required", type: "boolean", default: false },
      layout: {
        label: "Layout",
        type: "string",
        default: "inline",
        enum: ["inline", "wide"],
      },
      ...paramProperties,
    },
  },
];
